// eslint-disable prefer-template
const characterClass = "["
  + "\\w-"
  + "\u00C0-\u00D6" // Latin-1 Supplement (letters only)
  + "\u00D8-\u00F6"
  + "\u00F8-\u00FF"
  + "\u0100-\u0148" // Latin Extended-A (without deprecated character)
  + "\u014A-\u017F"
  + "\u0410-\u044F" // Cyrillic symbols: \u0410-\u044F
  + "\u3040-\u309F" // hiragana (japanese)
  + "\u30A0-\u30FF" // katakana (japanese)
  + "\u3130-\u318F" // Hangul Jamo (korean)
  + "\uAC00-\uD7A3" // Hangul Syllables (korean)
  + "\u4e00-\u9eff" // common chinese symbols
  + "]*";

export default new RegExp(`@(${characterClass}|\\s){0,}`, "g");
